import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef, useImperativeHandle, forwardRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert, Divider } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from "@hooks/useIndicator"
import MyTableHead from '@components/MyTableHead';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool, searchCompany } from '@util/helper';
import moment from 'moment';
import 'moment/locale/ko'
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';

//
import { Calendar, momentLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '@scss/App.scss'
import useAlert from "@hooks/useAlert";
import {Menu} from "@mui/material";
import Paper from "@mui/material/Paper"
import Dialog from '@mui/material/Dialog';
import { makeStyles } from '@mui/styles';
import MyDialog2 from '@components/MyDialog2';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import WbSunnyOutlined from '@mui/icons-material/WbSunnyOutlined';

const localizer = momentLocalizer(moment)

/* event sample
const events = [
    {
      title: 'Event 1',
      start: new Date('2023-07-13T10:00:00'),
      end: new Date('2023-07-13T12:00:00'),
    },
    {
      title: 'Event 2',
      start: new Date('2023-07-14T14:00:00'),
      end: new Date('2023-07-14T16:00:00'),
    },
  ];
*/

const useStyles = makeStyles({
  list: {
    padding:'0'
  },
});

const EventMenu = forwardRef((props, ref) => {
  const {dayEvents} = props
  const [anchorEl, set_anchorEl] = useState(null)
  const classes = useStyles()
  useImperativeHandle(ref, () =>({
    openMenu: (event) => {
      event.currentTarget.getBoundingClientRect()
      set_anchorEl(event.currentTarget)
    },
    closeMenu: () => {
      set_anchorEl(null) 
    }
  }))
  
  const btnRef = useRef()
  return (
    <>
      <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => set_anchorEl(null)} MenuListProps={{disablePadding:true}}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "left" }} 
      >
        <div style={{padding:20,backgroundColor:'#fff9c4', minWidth:200}}>
          {
            dayEvents && dayEvents.map(evt => (
              <div style={{marginBottom:5}}>
                <Typography variant='body2'> {evt.title} </Typography>
                <Typography variant='body2' fontSize={'0.8em'}> {evt.eventTime}</Typography>
              </div>
            ))
          }
        </div>
      </Menu>
    </>
  )
})

const TeacherCalendarPage = () => {

  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)
  const theme = useTheme() 
  const [view, set_view] = useState('month')
  const [date, set_date] = useState(moment().toDate())
  const [loaded, set_loaded] = useState(false)
  const location = useLocation()
  const curLocationRef = useRef(location)
  // calendar
  const formats = {
    // dayFormat: (date, culture, localizer) => localizer.format(date, 'ddd', culture),
    monthHeaderFormat: (date, culture, localizer) => localizer.format(date, 'YYYY년 MMMM', culture),
    agendaDateFormat: (date, culture, localizer) => localizer.format(date, 'MMMM DD일(ddd)', culture),
  }
  const holidaysRef = useRef([])

  const messages = {
    today:'현재',
    previous:'이전',
    next:'다음',
    month: '월',
    week:'주',
    day:'일',
    agenda:'어젠다',
    noEventsInRange: '기간 중 데이터가 없습니다.',
    date: '날짜',
    time: '시간',
    event: '이벤트',
    showMore: total => (
      <div
        style={{ cursor: 'pointer' }}
        onMouseOver={e => {
          e.stopPropagation();
          e.preventDefault();
        }}
        onClick={e => {
          // e.stopPropagation();  
          // e.preventDefault();
          console.log('e ==>', e)
          menuRef.current.openMenu(e)
        }}
      >{`+${total} 있음`}
      </div>
    ),
  }

  const CustomEvent = ({event}) => {
    const startStr = moment(event.start).format('HH:mm')
    const endStr = moment(event.end).format('HH:mm')
    const eventTime = startStr !== endStr ? `(${startStr} ~ ${endStr})` : ''

    return (
      <div >
        <div style={{fontSize:'0.9em'}}>{event.title} {eventTime}</div>
        {/* <div style={{fontSize:'12px'}}>{eventTime}</div> */}
      </div>
    );
  }

  const CustomDateHeader= (props) => {
    return (
      <div style={{
        fontSize:'0.8em',
        color: isHoliday(props.date) ? 'red' : null
      }}
      >{props.label}</div>
    );
  }

  const eventPropGetter = (event, start, end, isSelected) => {
    return  {
      style: {
        // backgroundColor:theme.palette.primary.main,
        // backgroundColor:'#fff',
        backgroundColor:'transparent',
        color: isHoliday(start) ? 'red' : '#212121',
        fontSize: '14px',
      },
    }
  }

  const dgRef = useRef()


  //
  const navigate = useNavigate()
  const {alert, renderAlert} = useAlert()

  //
  const [openSnackbar] = useSnackbar()
	const [openIndicator, closeIndicator, renderIndicator] = useIndicator()

  const [events, set_events] = useState([])
  const [dayEvents, set_dayEvents] = useState([])
  const menuRef = useRef()

  const fetchSmsts = async() => {
    const url = `/smst/last/4/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url, {})
    closeIndicator()
    if(resp.repCode === 'reject') {
      navigate('/login')
    }

    if(resp.repCode !== 'ack') {
      openSnackbar(resp.repMessage)
      return []
    }

    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const fetchNotices = async() => {
    const url = `/notice/school/${schola.id}` 
    const resp = await WebService.get(url,  {
      catCode:'S002'
    })

    if(resp.repCode !== 'ack') {
      return
    }
    
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    return records
  }

  const fetchLschs = async(smstId) => {
    const url = `/calendar/smst/${smstId}`
    openIndicator()
    const resp = await WebService.get(url, {})
    closeIndicator()
    if(resp.repCode !== 'ack') {
      return []
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const fetchHolidays = async() => {
    const url = `/holiday/school/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      openSnackbar('공휴일 데이터를 가져올 수 없습니다.')
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    return records
  }

  const isHoliday = (date) => {
    const day = moment(date).day()
    if(day == 0) {
      return true
    }

    const dt = moment(date).format('YYYYMMDD')
    if(holidaysRef.current.filter(r => r.locDate === dt).length > 0) {
      return true
    }
    return false
  }

  const onLoad = async() => {
    const events = []

    const holidays = await fetchHolidays()
    if(holidays) {
      holidaysRef.current = holidays
      for(const d of holidays) {
        const event = {
          title: d.dateName,
          start: moment(d.locDate, 'YYYY-MM-DD').toDate(),
          end: moment(d.locDate, 'YYYY-MM-DD').toDate()
        }
        events.push(event)
      }
    }

    const smsts = await fetchSmsts()
    if(smsts) {
      for(const smst of smsts) {
        events.push({
          title: `제${smst.gisu}기 수강신청 시작`,
          start: moment(smst.regiStime, "YYYY-MM-DD HH:mm:ss").toDate(),
          end: moment(smst.regiStime, "YYYY-MM-DD HH:mm:ss").toDate()
        })

        events.push({
          title: `제${smst.gisu}기 수강신청 종료`,
          start: moment(smst.regiEtime, "YYYY-MM-DD HH:mm:ss").toDate(),
          end: moment(smst.regiEtime, "YYYY-MM-DD HH:mm:ss").toDate()
        })

        events.push({
          title: `제${smst.gisu}기 수강신청 확정`,
          start: moment(smst.regiFtime, "YYYY-MM-DD HH:mm:ss").toDate(),
          end: moment(smst.regiFtime, "YYYY-MM-DD HH:mm:ss").toDate()
        })

        events.push({
          title: `제${smst.gisu}기 강좌 시작`,
          start: moment(smst.lectureStime, "YYYY-MM-DD HH:mm:ss").toDate(),
          end: moment(smst.lectureStime, "YYYY-MM-DD HH:mm:ss").toDate()
        })

        events.push({
          title: `제${smst.gisu}기 강좌 종료`,
          start: moment(smst.lectureEtime, "YYYY-MM-DD HH:mm:ss").toDate(),
          end: moment(smst.lectureEtime, "YYYY-MM-DD HH:mm:ss").toDate()
        })

        
        let lschs = await fetchLschs(smst.id)
        if(!lschs) {
          return
        }

        // 출강 강좌만 보여줌.
        lschs = lschs.filter(r => +r.misc.teacherId === +account.user.id)
        for(const lsch of lschs) {
          const start = moment(lsch.start, "YYYY-MM-DD HH:mm:ss").toDate()
          const event = {
            title: lsch.title,
            start: start,
            end: moment(lsch.end, "YYYY-MM-DD HH:mm:ss").toDate()
          }
          
          if(!isHoliday(start)) {
            events.push(event)
          }
          

          if(lsch.subStart) {
            event.title= `(취)${lsch.title}`
            console.log(`lsch:${lsch} has subStart`)
            const subStart = moment(lsch.subStart, "YYYY-MM-DD HH:mm:ss").toDate()
            const subEnd = moment(lsch.subEnd, "YYYY-MM-DD HH:mm:ss").toDate()
            const subEvent = {
              title: '(보)' + lsch.title,
              start: subStart,
              end: subEnd
            }
            events.push(subEvent)
          }
        }
      }
    }

    const noticeEvents = await fetchNotices()
    if(noticeEvents) {
      for(const d of noticeEvents)  {
        const event = {
          title: d.title,
          start: moment(d.sTime, "YYYY-MM-DD HH:mm:ss").toDate(),
          end: moment(d.eTime, "YYYY-MM-DD HH:mm:ss").toDate()
        }
        events.push(event)
      }
    }
    set_events(events)
    set_loaded(true)
  }

  const onShowMore = (event, date) => {
    console.log('onShowmore ==> event', event)
    const dayEvents =[]
    for(const data of event) {
      const startStr = moment(data.start).format('HH:mm'); // Format start time
      const endStr = moment(data.end).format('HH:mm'); // Format end time
      const eventTime = `(${startStr} ~ ${endStr})`
      const e = {
        title:data.title,
        eventTime: eventTime
      }
      dayEvents.push(e)
    }
    set_dayEvents(dayEvents)

  }

  const onSelectEvent = (event) => {
  }

  const onSelectSlot = (slotInfo) => {
  }

  useEffect(() => {
    onLoad()
  }, [])

  useEffect(() => {
    if(curLocationRef.current.key !== location.key) {
      onLoad()
      curLocationRef.current = location
    }
  },[location])


  const dayPropGetter = (date) => {
    const day = moment(date).day()
    return {
      style: {
        // backgroundColor: isHoliday(date) ? '#ffebee' : null
      }
    }
  }
  return(
    <div>
      {
        loaded ? (
          <>
            
            <Divider style={{borderWidth:0, marginBottom:10 }}/>
            <Calendar
              localizer={localizer}
              events={events}
              startAccessor="start"
              endAccessor="end"
              formats={formats}
              messages={messages}
              view = {view}
              onView={(newView) => set_view(newView)}
              eventPropGetter={eventPropGetter}
              dayPropGetter={dayPropGetter}
              onSelectEvent={onSelectEvent}
              onShowMore={onShowMore}
              selectable
              popup={true}
              style={{ height: view === 'day' ? '85vh' : '600px'}}  onSelectSlot={onSelectSlot}
              // Use CustomEvent only for the month view
              components={{
                month: {
                  event: (props) => (
                    <CustomEvent {...props} />
                  ),
                  dateHeader: (props) => (
                    <CustomDateHeader {...props} />
                  )
                },
              }}
            />
          </>
        ) : null
      }

      {renderIndicator()}
      {renderAlert()}
      <EventMenu ref={menuRef} dayEvents={dayEvents}/>
    </div>
  )
}

export default TeacherCalendarPage
